import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaTimes } from "react-icons/fa";

const LogNav = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const role = localStorage.getItem("userRole"); 

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  const clearDataHandler = (event) => {
    event.preventDefault();
    localStorage.clear();
    window.location.href = "/club-login";
  };

  const defaultNavLinks = [
    { link: "/loged-user-home", page: "Home" },
    { link: "/loged-user-prof", page: "Club profile" },
    { link: "/loged-user-courses", page: "Courses" },
    { link: "/loged-user-competition", page: "Competition" },
    { link: "/courses-alert", page: "Alerts" },
    { link: "/courses-live-view", page: "Live View" },
    { link: "/IncidentsLog", page: "Incident Log" },
    { link: "/billing", page: "Billing" },
    { link: "/delete-account", page: "Delete Account" },
  ];

  const superAdminLinks = [
   
    { link: "/all-club-courses", page: "Club List" }, 
  ];

  const navLinks = role === "SuperAdmin" ? superAdminLinks : defaultNavLinks;

  return (
    <>
      <div className="candybox-menu" onClick={toggleSidebar}>
        {Array.from({ length: 9 }).map((_, i) => (
          <div className="candybox-dot" key={i}></div>
        ))}
      </div>

      {isSidebarOpen && <div className="overlay" onClick={closeSidebar}></div>}

      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={closeSidebar}>
          <FaTimes />
        </button>

        <ul className="sidebar__nav">
          {navLinks.map((link, index) => (
            <li key={index} className="sidebar__nav__item">
              <NavLink
                to={link.link}
                className="sidebar__nav__item-link"
                onClick={closeSidebar}
              >
                {link.page}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="sidebar__nav-links">
          <NavLink
            to="/club-login"
            className="res-btn-primary"
            onClick={clearDataHandler}
          >
            Log Out
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default LogNav;
